import { Picture } from './picture';

export const PictureTypes = [
    'PICTURE',
    'LOGO',
    'HOTEL',
    'FLIGHTPAGE',
    'HOMEPAGE',
    'DEFAULT_EXCURSIONS',
    'DEFAULT_INSURANCES',
    'DEFAULT_TRANSFERS',
    'DEFAULT_TRAINS'
] as const;

export type PictureType = typeof PictureTypes[number];

export type PictureState = {
    adding: boolean,
    alt: string,
    count: number,
    create: boolean,
    create_tab: 0 | 1,
    create_alt: string | null,
    create_credit: string | null,
    create_description: string | null,
    create_name: string | null,
    create_type: PictureType,
    credits: string,
    cropper: any,
    description: string,
    description_error: string,
    filter_open: boolean,
    filter_types: PictureType[],
    files: any[],
    keep: boolean,
    limit: number,
    list: Picture[] | null,
    name: string,
    name_error: string,
    page: number,
    picture: null | Picture,
    progress: number,
    queries: {
        key: string,
        query: unknown
    }[],
    refresh: boolean,
    running: boolean,
    search: string,
    selection: Picture[]
};
